/**
 * A super module that collects available sub-modules.
 *
 * @namespace vef.utils.template
 * @memberof vef
 */

export * from './enhanceHTML.js';
export * from './resolveTemplate.js';
export * from './resolveComplexTemplate.js';
export * from './convertUnits.js';